<div
  class="formfield"
  [ngStyle]="{
    marginBottom:
      !manualMode && !searchFailed && getValue('street') && getValue('city')
        ? 0
        : null,
  }"
>
  <div [formGroup]="addressForm">
    <!-- Postcode - full width -->
    <div class="formfield postcode-row">
      <nes-input
        [label]="'USER_DATA.INPUT.POSTCODE.LABEL' | translate"
        [name]="'USER_DATA.INPUT.POSTCODE.NAME' | translate"
        [placeholder]="'USER_DATA.INPUT.POSTCODE.PLACEHOLDER' | translate"
        [value]="addressForm.get('postcode')!.value"
        [formControl]="getControl('postcode')"
        formControlName="postcode"
        [cypress]="'postcode'"
        nesFormControl
        controlled
        required
        forceUppercase
        receiptFooterVisibility
        privacySensitive
        [maxLength]="postcodeLength"
        nes-id="postcode"
        type="text"
      ></nes-input>
      @if (getPostcodeErrorKey() !== undefined) {
        <nes-error-message>{{ getPostcodeErrorKey() }}</nes-error-message>
      }
    </div>

    <!-- Huisnummer + Toevoeging side by side -->
    <div class="nes-grid nes-grid-cols-2 nes-gap-x-5 housenumber-addition-row">
      <div class="formfield">
        <nes-input
          [label]="'USER_DATA.INPUT.HOUSENUMBER.LABEL' | translate"
          [name]="'USER_DATA.INPUT.HOUSENUMBER.NAME' | translate"
          [placeholder]="'USER_DATA.INPUT.HOUSENUMBER.PLACEHOLDER' | translate"
          [value]="addressForm.get('houseNumber')!.value"
          [formControl]="getControl('houseNumber')"
          formControlName="houseNumber"
          [cypress]="'house_number'"
          nesFormControl
          controlled
          required
          receiptFooterVisibility
          privacySensitive
          maxLength="10"
          nes-id="houseNumber"
          type="number"
        ></nes-input>
        @if (getHouseNumberErrorKey() !== undefined) {
          <nes-error-message>{{ getHouseNumberErrorKey() }}</nes-error-message>
        }
      </div>

      <div class="formfield">
        <nes-input
          [label]="'USER_DATA.INPUT.ADDITION.LABEL' | translate"
          [name]="'USER_DATA.INPUT.ADDITION.NAME' | translate"
          [placeholder]="'USER_DATA.INPUT.ADDITION.PLACEHOLDER' | translate"
          [value]="addressForm.get('addition')!.value"
          [formControl]="getControl('addition')"
          formControlName="addition"
          [cypress]="'addition'"
          nesFormControl
          controlled
          receiptFooterVisibility
          privacySensitive
          maxLength="10"
          nes-id="addition"
          type="text"
        ></nes-input>
      </div>
    </div>
  </div>
</div>

<nes-message-inline
  class="formfield"
  type="error"
  *ngIf="getAddressErrorKey() !== undefined"
  [heading]="'USER_DATA.INPUT.ADDRESS.ERROR_INVALID' | translate"
>
  <nes-text class="nes-mb-3">{{ getAddressErrorKey() | translate }}</nes-text>

  <nes-button
    icon-leading="edit"
    compact
    (nesOnClick)="manual.emit(true)"
    variant="primary"
  >
    {{ "USER_DATA.INPUT.ADDRESS.MANUAL" | translate }}
  </nes-button>
</nes-message-inline>

<ng-container *ngIf="addressLoading; else address">
  <div class="formfield__inputContainer loader">
    <div class="basicLoader"></div>
  </div>
</ng-container>

<ng-template #address>
  <ng-container
    *ngIf="
      searchableAddress &&
      !manualMode &&
      !searchFailed &&
      getValue('street') &&
      getValue('city')
    "
  >
    <div
      id="address_result"
      class="address-result formfield animated pulse nes-mt-5"
      [cypress]="'address_result'"
    >
      <div class="address-result__bar"></div>
      <div class="address-result__content">
        <div class="address-result__label">
          <div class="address-result__icon">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.5 11.5L3 8L4.5 6.5L6.5 8.5L11.5 3.5L13 5L6.5 11.5Z" fill="white"/>
            </svg>
          </div>
          <span>{{ "USER_DATA.INPUT.ADDRESS.LABEL" | translate }}</span>
        </div>
        <span class="address-result__address" privacySensitive>
          {{ getValue("street") }} {{ getValue("houseNumber") }}, {{ getValue("city") }}
        </span>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-container *ngIf="manualMode || !searchableAddress">
  <div [formGroup]="addressForm" class="manual-address-fields">
    <div class="formfield">
      <nes-input
        [label]="'USER_DATA.INPUT.STREET.LABEL' | translate"
        [name]="'USER_DATA.INPUT.STREET.NAME' | translate"
        [value]="addressForm.get('street')!.value"
        formControlName="street"
        nesFormControl
        controlled
        required
        receiptFooterVisibility
        privacySensitive
        [forceUppercase]="{ firstLetterOnly: true }"
        [cypress]="'street'"
        [maxLength]="50"
        nes-id="street"
        type="text"
      ></nes-input>
      @if (getStreetErrorKey() !== undefined) {
        <nes-error-message>
          {{ getStreetErrorKey() | translate }}
        </nes-error-message>
      }
    </div>

    <div class="formfield">
      <nes-input
        [label]="'USER_DATA.INPUT.CITY.LABEL' | translate"
        [name]="'USER_DATA.INPUT.CITY.NAME' | translate"
        [value]="addressForm.get('city')!.value"
        formControlName="city"
        nesFormControl
        controlled
        required
        privacySensitive
        [error]="getCityErrorKey() | translate"
        receiptFooterVisibility
        [forceUppercase]="{ firstLetterOnly: true }"
        [cypress]="'city'"
        [maxLength]="50"
        nes-id="city"
        type="text"
      ></nes-input>
    </div>
  </div>
</ng-container>
